import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BeachtennisComponent } from './beachtennis.component';
import { BeachtennisHomeComponent } from './components/home/beachtennis-home.component';
import { BeachtennisAttachedComponent } from './components/attached/beachtennis-attached.component';
import { BeachtennisRankingComponent } from './components/ranking/list/beachtennis-ranking.component';
import { BeachtennisRankingClassifComponent } from './components/ranking/classification/beachtennis-ranking-classif.component';
import { BeachtennisRankingHistoryComponent } from './components/history/beachtennis-ranking-history.component';
import { SharedAttachmentsDetailComponent } from '@theme/components';

const routes: Routes = [
    {
        path: '',
        component: BeachtennisComponent,
        children: [
            { path: 'home', component: BeachtennisHomeComponent },
            {
                path: 'tournament',
                loadChildren: () => import('../tournament/tournament.module').then((m) => m.TournamentModule),
            },
            { path: 'ranking-2', loadChildren: () => import('../ranking/ranking.module').then((m) => m.RankingModule) },
            { path: 'ranking', component: BeachtennisRankingComponent },
            { path: 'history', component: BeachtennisRankingHistoryComponent },
            {
                path: 'ranking-classif/:rankingId',
                component: BeachtennisRankingClassifComponent,
            },
            {
                path: 'attached/:sessionType',
                component: BeachtennisAttachedComponent,
            },
            { path: 'attached/:sessionType/detail/:docId', component: SharedAttachmentsDetailComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BeachtennisRoutingModule {}
